import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { AutoCompleteExtraProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { SettingsFormTypes } from "models/formTypes";
import { CompanyFormProps } from "models/propTypes/settingsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { AddSupportCaseLink } from "components/support";
//#endregion
import { CountryHelper, LocalizationHelperInstance } from "utils/helpers";

const CompanySettingsForm: ForwardRefRenderFunction<FormHandles, CompanyFormProps> = (props, ref) => {
  return (
    <GenericForm<SettingsFormTypes.CompanySettings>
      formRef={ref}
      inline
      {...props}
      fields={[
        {
          label: TranslationKeys.Settings.Information,
          type: FormEnums.FormSectionType.FIELDGROUPSECTION,
          icon: IconDefinitionConstants.WInfo,
          innerFields: {
            name: {
              label: TranslationKeys.Common.Name,
              descriptionText: (
                <>
                  <AddSupportCaseLink />{" "}
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.CompanyNameDescription)}
                </>
              ),
              type: FormEnums.FormFieldType.TEXT,
              disabled: true,
            },
            orgNumber: {
              label: TranslationKeys.Settings.CompanyOrgNumber,
              descriptionText: (
                <>
                  <AddSupportCaseLink />{" "}
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.CompanyOrgNumberDescription)}
                </>
              ),
              type: FormEnums.FormFieldType.TEXT,
              disabled: true,
            },
            phone: {
              label: TranslationKeys.Settings.CompanyPhone,
              descriptionText: TranslationKeys.Settings.CompanyPhoneDescription,
              type: FormEnums.FormFieldType.TEXT,
            },
            mail: {
              label: TranslationKeys.Settings.CompanyMail,
              descriptionText: TranslationKeys.Settings.CompanyMailDescription,
              type: FormEnums.FormFieldType.TEXT,
            },
            companyImage: {
              label: TranslationKeys.Settings.CompanyLogo,
              descriptionText: TranslationKeys.Settings.CompanyLogoDescription,
              type: FormEnums.FormFieldType.FILEUPLOADER,
              extraProps: { fileUploaderType: "full", maxFileCount: 1 },
            },
          },
        },
        {
          label: TranslationKeys.Settings.Addresses,
          type: FormEnums.FormSectionType.FIELDGROUPSECTION,
          icon: IconDefinitionConstants.WPin,
          innerFields: {
            visitorStreet1: {
              label: TranslationKeys.Settings.VisitingAddress,
              descriptionText: TranslationKeys.Settings.VisitingAddressDescription,
              type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
              innerFields: {
                visitorStreet1: {
                  label: TranslationKeys.Common.StreetAddress,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 12,
                },
                visitorStreet2: {
                  label: TranslationKeys.Common.StreetAddress2,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 12,
                },
                visitorZipCode: {
                  label: TranslationKeys.Common.PostalCode,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 4,
                },
                visitorCity: {
                  label: TranslationKeys.Common.City,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 8,
                },
                visitingCountryName: {
                  label: TranslationKeys.Common.Country,
                  type: FormEnums.FormFieldType.AUTOCOMPLETE,
                  widthColumnCount: 12,
                  extraProps: {
                    referenceFieldName: FormFieldConstants.Settings.CompanySettings.VisitingCountryCode,
                    items: CountryHelper.getCountryAutoCompleteList(),
                  } as AutoCompleteExtraProps<SettingsFormTypes.CompanySettings>,
                },
              },
            },
            billingStreet1: {
              label: TranslationKeys.Settings.BillingAddress,
              type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
              innerFields: {
                billingStreet1: {
                  label: TranslationKeys.Common.StreetAddress,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 12,
                  disabled: true,
                },
                billingStreet2: {
                  label: TranslationKeys.Common.StreetAddress2,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 12,
                  disabled: true,
                },
                billingZipCode: {
                  label: TranslationKeys.Common.PostalCode,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 4,
                  disabled: true,
                },
                billingCity: {
                  label: TranslationKeys.Common.City,
                  type: FormEnums.FormFieldType.TEXT,
                  widthColumnCount: 8,
                  disabled: true,
                },
                billingCountryName: {
                  label: TranslationKeys.Common.Country,
                  type: FormEnums.FormFieldType.AUTOCOMPLETE,
                  widthColumnCount: 12,
                  disabled: true,
                  extraProps: {
                    referenceFieldName: FormFieldConstants.Settings.CompanySettings.BillingCountryCode,
                    items: CountryHelper.getCountryAutoCompleteList(),
                  } as AutoCompleteExtraProps<SettingsFormTypes.CompanySettings>,
                },
              },
            },
          },
        },
      ]}
    />
  );
};

export default forwardRef(CompanySettingsForm);
